import { FlaskConical } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * BLU-374: amber TEST badge stamped wherever a synthetic order or batch
 * is rendered. Drives at-a-glance recognition that an item is fake data
 * and shouldn't be treated as a real production unit.
 */
export function TestOrderBadge({
  size = 'sm',
  className,
}: {
  size?: 'sm' | 'xs';
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-sm font-semibold uppercase tracking-wide',
        'border border-amber-500/50 bg-amber-500/15 text-amber-700',
        'dark:border-amber-400/40 dark:bg-amber-500/20 dark:text-amber-200',
        size === 'xs'
          ? 'px-1 py-0 text-[9px] leading-4'
          : 'px-1.5 py-0.5 text-[10px] leading-4',
        className,
      )}
      title="Synthetic test order. Skips StarShipIt and Shopify on completion."
      aria-label="Test order"
    >
      <FlaskConical
        className={cn(size === 'xs' ? 'h-2.5 w-2.5' : 'h-3 w-3')}
        aria-hidden="true"
      />
      Test
    </span>
  );
}
